import { ApplicantOfferStatus, ApplicantStatusReason, IOption } from 'types';

export const offerNeedsReissueStatuses = [
  ApplicantOfferStatus.Conditional,
  ApplicantOfferStatus.Unconditional,
  ApplicantOfferStatus.Withdrawn
];

export const statusReasonOptions: IOption[] = [
  { label: 'Entry criteria not met', value: ApplicantStatusReason.EntryCriteriaNotMet },
  { label: 'Failed academic assessment', value: ApplicantStatusReason.FailedAcademicAssessment },
  { label: 'Failed credibility assessment', value: ApplicantStatusReason.FailedCredibilityAssessment },
  { label: 'Fraudulent application', value: ApplicantStatusReason.FraudulentApplication },
  { label: 'Course closure', value: ApplicantStatusReason.CourseClosure },
  { label: 'Course full', value: ApplicantStatusReason.CourseFull },
  { label: 'Unable to offer course to applicant', value: ApplicantStatusReason.UnableToOfferCourse },
  { label: 'Deadline has passed', value: ApplicantStatusReason.DeadlineHasPassed },
  { label: 'Closed by applicant', value: ApplicantStatusReason.ClosedByApplicant },
  { label: 'Other', value: ApplicantStatusReason.Other }
];

export const OfferTooltipLabels = {
  applicantAccepted: 'The applicant has accepted this offer',
  applicantDeclined: 'Applicant has declined this offer',
  pendingChanges: 'Offer edited since it was last issued',
  pendingChangesByApplicant: 'Applicant has provided new information',
  newDocumentsCount: (count: number) => {
    if (count === 1) {
      return `${count} new update from applicant`;
    }
    return `${count} new updates from applicant`;
  }
};
